<div>
    <h2 class="mat-subheading-2">Generación de requerimiento</h2>
</div>
<div class="terms-and-conditions container mx-auto px-7 pb-3 block">
    <div class="w-full columns-1 w-4/5 mx-auto">
    </div>
    <div>
        <div *ngIf="validData">
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <mat-form-field>
                    <mat-label>Ingresa la contraseña</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" formControlName="contrasena">
                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Ver contraseña'"
                        [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>
                <div class="error-component">
                    <span
                        *ngIf="(registerFormControl.contrasena.touched || submitted) && registerFormControl.contrasena.errors?.required">
                        Campo requerido
                    </span>
                    <span
                        *ngIf="registerFormControl.contrasena.touched && registerFormControl.contrasena.errors?.invalidMinSize">
                        <p>La contraseña debe contener un mínimo de 12 carácteres</p>
                    </span>
                    <span
                        *ngIf="registerFormControl.contrasena.touched && registerFormControl.contrasena.errors?.invalidMaxSize">
                        <p>La contraseña debe contener un máximo de 32 carácteres</p>
                    </span>
                    <span
                        *ngIf="registerFormControl.contrasena.touched && registerFormControl.contrasena.errors?.invalidPassword">
                        <p>La contraseña debe contener al menos una letra mayúscula, una letra minúscula y un número del 0 al 9</p>
                    </span>
                </div>
                <mat-form-field>
                    <mat-label>Confirmar contraseña</mat-label>
                    <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="contrasenaConfirma">
                    <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm" [attr.aria-label]="'Ver contraseña'"
                        [attr.aria-pressed]="hideConfirm">
                        <mat-icon>{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>
                <div class="error-component">
                    <span 
                        *ngIf="(registerFormControl.contrasenaConfirma.touched || submitted)&& registerFormControl.contrasenaConfirma.errors?.required">
                        Campo requerido
                    </span>
                    <span 
                        *ngIf="registerFormControl.contrasenaConfirma.touched && registerFormControl.contrasenaConfirma.errors?.passwordMismatch">
                        Las contraseñas no coinciden
                    </span>
                </div>
                <!-- <div class="content-button">
                    <button [disabled]="registerForm.invalid ? true : null" mat-raised-button type="submit"
                        color="accent">
                    Guardar
                </button>
                </div> -->
            </form>
        </div>

        <div class="instruction">
            <span>
                La contraseña debe ser de mínimo 12 carácteres, máximo 32 carácteres, contener al menos una letra mayúscula, una letra minúscula y un número del 0 al 9.
            </span>
        </div>

        <div *ngIf="!validData" class="error-component">
            <span>
                No hay información suficiente para generar el requerimiento
            </span>
        </div>

        <div *ngIf="errorGenerateCsr" class="error-component">
            <span>
                Ocurrió un error al generar el requerimiento
            </span>
        </div>

        <div class="content-button" *ngIf="showDownload">
            <button mat-raised-button type="button" (click)="descragar()"
                color="accent">
            Descargar
        </button>
        </div>
    </div>
</div>
